import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {useAxiosPrivate} from "../useAxiosPrivate";
import {useContext} from "react";
import {AuthContext} from "../../context/AuthContext";

export const useAnnouncementQueries = () => {
    const axiosPrivate = useAxiosPrivate();
    const queryClient = useQueryClient();
    const {isAuthenticated} = useContext(AuthContext)


    const announcementsQuery = useQuery({
        queryKey: ['announcements'],
        queryFn: () => axiosPrivate.get('/announcements/').then(r => r.data),
        enabled: isAuthenticated
    });


    const seeAnnouncementMutation = useMutation({
        mutationFn: (id) => axiosPrivate.get(`/announcements/${id}/see-announcement/`).then(r => r.data),
        onSuccess: () => {
            queryClient.invalidateQueries(['announcements']);
        }
    });


    const dismissAnnouncementMutation = useMutation({
        mutationFn: (id) => axiosPrivate.get(`/announcements/${id}/dismiss-announcement/`).then(r => r.data),
        onSuccess: () => {
            queryClient.invalidateQueries(['announcements']);
        }
    });


    return {
        announcementsQuery,
        seeAnnouncementMutation,
        dismissAnnouncementMutation
    };
};